module.exports = new __parcel__URL__("rassvetLogoWithoutName.a3f3b4b2.png").toString();